import React from "react";
import { Tooltip } from "antd";
import { FaRegCopy } from "react-icons/fa6";
import { UserDefinedFlag } from "@store/reducers/userDefinedFlags.reducer";

interface CopyFlagButtonProps {
    flag: UserDefinedFlag;
    onDuplicate: (flag: UserDefinedFlag) => void;
}

export const CopyFlagButton: React.FC<CopyFlagButtonProps> = ({ flag, onDuplicate }) => {
    return (
        <Tooltip title="Create a copy">
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    onDuplicate(flag);
                }}
                style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px 8px",
                    display: "flex",
                    alignItems: "center",
                    color: "#1890ff",
                    fontSize: "14px",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#40a9ff")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#1890ff")}
            >
                <FaRegCopy />
            </button>
        </Tooltip>
    );
};

export default CopyFlagButton;
